import { render, staticRenderFns } from "./DashboardActionsModal.vue?vue&type=template&id=5850a81f&scoped=true&"
import script from "./DashboardActionsModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardActionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850a81f",
  null
  
)

export default component.exports